import { Id } from "PFTypes";

export const bookingEngagementsKeys = {
  all: () => ["bookingEngagements"],
  economicsAll: () => [...bookingEngagementsKeys.all(), "economics"],
  economics: (ids: Id[]) => [...bookingEngagementsKeys.economicsAll(), JSON.stringify(ids)]
};
